module.exports = __webpack_public_path__ + "officialStatic/img/meidiLogo.d17b90c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/meidiLogo.png
// module id = Qde/
// module chunks = 0